import React from 'react'
import { Outlet } from 'react-router-dom'

function LabTests() {
    return (
        <Outlet />
    )
}

export default LabTests